export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-8 lg:px-20 py-24">
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          <div className="md:col-span-2 space-y-6">
            <img 
              src="https://static.readdy.ai/image/ddc6dbc53596691e38d04fbd711f3d87/cec43e6d74cb0ebaf8d97e3cce2e1f27.png" 
              alt="Mansa Musa JH" 
              className="h-16 w-auto"
            />
            <p className="text-gray-400 leading-loose max-w-md text-sm">
              Cultura não é entretenimento isolado.
              <br />
              É estrutura. É impacto. É desenvolvimento.
            </p>
            <div className="flex gap-4 pt-4">
              <a
                href="https://www.instagram.com/mansamusajh/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gold/30 rounded-full text-gold hover:bg-gold hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.youtube.com/@mansamusajh011"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gold/30 rounded-full text-gold hover:bg-gold hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
              <a
                href="https://wa.me/5511983562550"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center border border-gold/30 rounded-full text-gold hover:bg-gold hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-whatsapp-line text-lg"></i>
              </a>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="text-gold text-xs uppercase tracking-[0.3em] font-semibold mb-6">
              Navegação
            </h4>
            <button
              onClick={() => scrollToSection('conceito')}
              className="block text-gray-400 text-sm hover:text-white hover:translate-x-1 transition-all duration-300 text-left cursor-pointer"
            >
              Conceito
            </button>
            <button
              onClick={() => scrollToSection('quem-somos')}
              className="block text-gray-400 text-sm hover:text-white hover:translate-x-1 transition-all duration-300 text-left cursor-pointer"
            >
              Quem Somos
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="block text-gray-400 text-sm hover:text-white hover:translate-x-1 transition-all duration-300 text-left cursor-pointer"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('projetos')}
              className="block text-gray-400 text-sm hover:text-white hover:translate-x-1 transition-all duration-300 text-left cursor-pointer"
            >
              Projetos
            </button>
          </div>

          <div className="space-y-4">
            <h4 className="text-gold text-xs uppercase tracking-[0.3em] font-semibold mb-6">
              Contato
            </h4>
            <a
              href="mailto:contato@mansamusajh.com.br"
              className="block text-gray-400 text-sm hover:text-white transition-colors duration-300"
            >
              contato@mansamusajh.com.br
            </a>
            <a
              href="https://wa.me/5511983562550"
              className="block text-gray-400 text-sm hover:text-white transition-colors duration-300"
            >
              +55 (11) 98356-2550
            </a>
            <p className="text-gray-400 text-xs leading-relaxed">
              São Paulo – Brasil
            </p>
            <button
              onClick={() => scrollToSection('contato')}
              className="inline-block mt-4 px-6 py-2 bg-gold text-black rounded-full text-xs font-semibold uppercase tracking-wider hover:bg-gold-light transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Seja parceiro
            </button>
          </div>
        </div>

        <div className="w-full h-px bg-gold/20 mb-8"></div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-gray-600">
          <p>© 2025 Mansa Musa JH. Todos os direitos reservados.</p>
          <div className="flex items-center gap-4">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gold hover:text-gold-light transition-colors duration-300">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-[280px] h-[180px] bg-gold/5 transform -rotate-12 -translate-x-20 translate-y-20"></div>
      <div className="absolute bottom-0 right-0 w-[280px] h-[180px] bg-gold/5 transform -rotate-12 translate-x-20 translate-y-20"></div>
    </footer>
  );
}
